import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent {

  roleForm!: FormGroup;
  displayContent: string = 'role-list';
  constructor(private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
      this.BuildRoleForm();
  }


  BuildRoleForm(){
    this.roleForm = this._formBuilder.group({
      roleName: ['',Validators.required],
      roleApplication: ['', Validators.required],
      roleDescription: ['', Validators.required],
      apiAccess1: false,
      apiAccess2: false,
      dashboardAccess1: false,
      dashboardAccess2: false,
      widgetAccess1: false,
      widgetAccess2: false
    })
  }
  
  onSubmit(){
    if(this.roleForm){
      console.log("Created role-info Data", this.roleForm.value);
    }
    else{
      console.log("role not created");
    }
  }

  showData(data: string){
    this.displayContent = data;
  }
}
